import React, { useState } from 'react';
import Countup from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';

const Countingnumber = () => {
    const [counteron,setCounteron] = useState(false)    

  return (
    <ScrollTrigger onEnter={()=>setCounteron(true)} onExit={()=>setCounteron(false)}>
        
        <div className="bg-black py-8 p-3">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-3 grid-cols-1 gap-5">
            <div className="text-center">
              <h1 className="text-[60px] font-bold text-orange"> {counteron &&  <Countup start={0} end={75} duration={4} delay={0}/>}+</h1>
              <p className="text-[20px] text-white">Projects Completed</p>
            </div>
            <div className="text-center">
              <h1 className="text-[60px] font-bold text-orange"> {counteron &&  <Countup start={0} end={200} duration={4} delay={0}/>}+</h1>
              <p className=" text-[20px] text-white">Proactive Team</p>
            </div>
            <div className="text-center">
              <h1 className="text-[60px] font-bold text-orange"> {counteron &&  <Countup start={0} end={150} duration={4} delay={0}/>}+</h1>
              <p className="text-[20px] text-white">Clients</p>
            </div>
          </div>
        </div>
      </div>
      </ScrollTrigger>
  )
}

export default Countingnumber